import { Inject, Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { RequestHeadCountDto, RequestReportSendEmailExcelDto, RequestReportSendEmailPdfDto } from "../../shared/nestjs/gd-only/dto/head-count-report.dto";
import { HeadCountReportApi } from "../../shared/nestjs/gd-only/services/head-count-report.api";
import { LoopBackAuth } from "../../shared/sdk";

@Injectable()
export class HeadCountReportBloc {
  private downloadData: RequestHeadCountDto = new RequestHeadCountDto();
  private requestSendEmailExcel: RequestReportSendEmailExcelDto = new RequestReportSendEmailExcelDto();
  private requestSendEmailPdf: RequestReportSendEmailPdfDto = new RequestReportSendEmailPdfDto();

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private headCountReportApi: HeadCountReportApi,
    private platform: Platform,
    private storage: Storage,
    private fileDownloaderProvider: FileDownloaderProvider,
    private analyticsProvider: AnalyticsProvider
  ) {
  }

  async downloadExcel(optData) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
    return await this.generateExcel(optData);
  }

  private async generateExcel(optData): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.downloadData.type = optData
      let downloadExcel = this.headCountReportApi.downloadExcel(this.downloadData).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadExcelBlob(result, 'Head Count ' + optData)
        } else {
          saveAs(result, 'Head Count ' + optData + '.xlsx')
        }
        resolve('Download SuccessFully')
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
      })
    })
  }

  async downloadPdf(optData) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
    return await this.generatePdf(optData)
  }

  private generatePdf(optData): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.downloadData.type = optData
      let downloadExcel = this.headCountReportApi.downloadPdf(this.downloadData).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadPdfBlob(result, 'Head Count ' + optData)
        } else {
          saveAs(result, 'Head Count ' + optData + '.pdf')
        }
        resolve('Download SuccessFully')
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
      })
    })
  }

  async sendEmailExcel(optData) {
    let storage = await this.storage.get('SFGoAuth')
    let SFGoAuth = JSON.parse(storage)
    this.requestSendEmailExcel.type = optData;
    this.requestSendEmailExcel.emailTo = SFGoAuth.email;
    this.requestSendEmailExcel.fullName = SFGoAuth.fullName;
    return await this.sendExcel(this.requestSendEmailExcel)
  }

  private sendExcel(data: RequestReportSendEmailExcelDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let sendExcel = this.headCountReportApi.reportSendEmailExcel(data)
        .subscribe(result => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          resolve(result.message)
        }, error => {
          reject(error.message)
        }, () => {
          sendExcel.unsubscribe()
        })
    })
  }

  async sendEmailPdf(optData) {
    let storage = await this.storage.get('SFGoAuth')
    let SFGoAuth = JSON.parse(storage);
    this.requestSendEmailPdf.type = optData;
    this.requestSendEmailPdf.emailTo = SFGoAuth.email;
    this.requestSendEmailPdf.fullName = SFGoAuth.fullName;
    return await this.sendPdf(this.requestSendEmailPdf)
  }

  private async sendPdf(data: RequestReportSendEmailPdfDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let sendExcel = this.headCountReportApi.reportSendEmailPdf(data)
        .subscribe(result => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          resolve(result.message)
        }, error => {
          reject(error.message)
        }, () => {
          sendExcel.unsubscribe()
        })
    })
  }



}




// WEBPACK FOOTER //
// ./src/bloc/report/head-count-report.bloc.ts